import React from "react";

interface OpenTabsContextType {
  openGlobalTabs: string[];
  removeGlobalTabName: string;
  setRemoveGlobalTabName: (name: string) => void;
  addGlobalTab: (tab: string) => void;
  removeGlobalTab: (tab: string) => void;
  removeAllGLobalTab: () => void;
}

export const OpenTabsContext = React.createContext<OpenTabsContextType>({
  openGlobalTabs: [],
  removeGlobalTabName: "",
  setRemoveGlobalTabName: () => {},
  addGlobalTab: () => {},
  removeGlobalTab: () => {},
  removeAllGLobalTab: () => {},
});
